import React, { Component } from 'react';  
import { Dimensions, Image, StyleSheet, Text, View, TouchableOpacity, Animated, Linking, I18nManager as RNI18nManager, AsyncStorage } from 'react-native';  
import { color } from '../config/color';
import { Ionicons } from "@expo/vector-icons";
import { ScrollView } from 'react-native-gesture-handler';
import { withNavigation } from 'react-navigation';
import store from "../config/config.json"
import i18n from 'i18n-js';
import Ln from '../assets/svg/Ln.svg'
import Fa from '../assets/svg/Fa.svg'
import In from '../assets/svg/In.svg'
import Wa from '../assets/svg/Wa.svg'
import Sn from '../assets/svg/Sn.svg'
import Te from '../assets/svg/Te.svg'
import Tw from '../assets/svg/Tw.svg'
const { width } = Dimensions.get('window')

class Menu extends Component {  

    state = {
		store: {},
        isShowing: false,
        opacity : new Animated.Value(0)
	}
	
	constructor(props){
		super(props)
		
		this.state.openLinks = props.openLinks
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth

		this.getData()		
    }

    getData = async () => {
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
			{
				value = JSON.parse(value)		
	            this.setState({store: value})
			}

        } catch (error) {
            console.log(error)
        }
    }  

    closeMenu(){
		this.props.changeState({showMenu: false});
    }

    switchToHome(){
		this.props.navigation.navigate("menu");
	}

	switchToBranches(){
		this.props.changeState({showMenu: false});
		this.props.navigation.navigate("branches");
	}

	switchToSearch(){
		this.props.changeState({showMenu: false});
		this.props.navigation.navigate("search");
	}

	switchToStatus(){
		this.props.changeState({showMenu: false});
		this.props.navigation.navigate("status");
	}

	openUrl(url){
		this.props.changeState({showMenu: false});
		window.open(url, "_blank") 
	}

    render() {  

		var icoName = "ios-arrow-forward"
		if(RNI18nManager.isRTL)
			icoName = "ios-arrow-back"

        return (  

            <View style={styles.container}>

                <View style={styles.topBar}>
					<TouchableOpacity style={{marginLeft: 15, height:40, width: 40, justifyContent: "center"}}
										onPress={() => { this.closeMenu() }}
								>
							{ RNI18nManager.isRTL && (<Ionicons name="ios-arrow-forward" size={24} color={color.mainIconColor} /> )}			 						
							{ !RNI18nManager.isRTL && (<Ionicons name="ios-arrow-back" size={24} color={color.mainIconColor} /> )}			 						
					</TouchableOpacity>
				</View>
		
        		<View style={{ borderBottomWidth: 1, borderBottomColor: color.menuUnselected}} />

                <ScrollView style={{flex: 1}}>

					<TouchableOpacity style={styles.button}
										onPress={() => { 
											if(this.props.title == 'Menu')
												this.closeMenu() 
											else
												this.switchToHome()
										}}
					>
						{ this.props.title == 'Menu' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: this.state.store.primaryColor}}>{i18n.t('menu')}</Text>)}		
						{ this.props.title != 'Menu' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('menu')}</Text>)}		
					</TouchableOpacity>

					<TouchableOpacity style={styles.button}
										onPress={() => { 
											if(this.props.title == 'Search')
												this.closeMenu() 
											else
												this.switchToSearch()
										}}
					>
						{ this.props.title == 'Search' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: this.state.store.primaryColor}}>{i18n.t('search')}</Text>)}		
						{ this.props.title != 'Search' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('search')}</Text>)}		
					</TouchableOpacity>

					<TouchableOpacity style={styles.button}
										onPress={() => { 
											if(this.props.title == 'Branches')
												this.closeMenu() 
											else
												this.switchToBranches()
										}}
					>
						{ this.props.title == 'Branches' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: this.state.store.primaryColor}}>{i18n.t('branches')}</Text>)}		
						{ this.props.title != 'Branches' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('branches')}</Text>)}		
					</TouchableOpacity>

					<TouchableOpacity style={styles.button}
										onPress={() => { 
											if(this.props.title == 'Status')
												this.closeMenu() 
											else
												this.switchToStatus()
										}}
					>
						{ this.props.title == 'Status' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: this.state.store.primaryColor}}>{i18n.t('orderStatus')}</Text>)}		
						{ this.props.title != 'Status' &&(<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('orderStatus')}</Text>)}		
					</TouchableOpacity>

					{this.state.store.linksList && (
						<TouchableOpacity style={styles.button}
											onPress={() => { 
												this.state.openLinks();
												this.closeMenu();
											}}
						>
							<Text style={{textAlign:'left',  fontFamily: 'main-regular',fontSize:16, color: 'black'}}>{i18n.t('links')}</Text>
						</TouchableOpacity>
					)}

					<View style={styles.imgGroup}>
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[0].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[0].link)}><Image source={Fa} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[3].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[3].link)}><Image source={Wa} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[1].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[1].link)}><Image source={In} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[6].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[6].link)}><Image source={Ln} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[4].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[4].link)}><Image source={Sn} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}	
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[2].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[2].link)}><Image source={Tw} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}
						{
							this.state.store.networkList != undefined &&
							this.state.store.networkList[5].status == true && (
								<TouchableOpacity style={{margin: width * 0.03}} onPress={()=>Linking.openURL(this.state.store.networkList[5].link)}><Image source={Te} style={{width: 40, height: 40, tintColor: this.state.store.primaryColor}} /></TouchableOpacity>
							)
						}						
					</View>

					{ this.state.store.links != undefined && (
						<View>
								<Text style={{fontFamily: 'main-regular',fontSize:13, fontWeight: "bold", textAlign:'left', marginLeft: 45, marginRight: 45, marginTop: 35, color: "#C5C5C9"}}>{i18n.t('otherLinks')}</Text>	
								{ this.state.store.links.whatsapp != undefined && this.state.store.links.whatsapp != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
														borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
														onPress={() => { this.openUrl(this.state.store.links.whatsapp) }}
									>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('whatsapp')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}

								{ this.state.store.links.instagram != undefined && this.state.store.links.instagram != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
														borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
														onPress={() => { this.openUrl(this.state.store.links.instagram) }}
									>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('instagram')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}
								{ this.state.store.links.snapchat != undefined && this.state.store.links.snapchat != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
														borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
														onPress={() => { this.openUrl(this.state.store.links.snapchat) }}
									>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('snapchat')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}
								{ this.state.store.links.twitter != undefined && this.state.store.links.twitter != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
													borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
													onPress={() => { this.openUrl(this.state.store.links.twitter) }}
													>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('twitter')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}
								{ this.state.store.links.facebook != undefined && this.state.store.links.facebook != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
														borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
														onPress={() => { this.openUrl(this.state.store.links.facebook) }}
									>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('facebook')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}
								{ this.state.store.links.telegram != undefined && this.state.store.links.telegram != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
														borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
														onPress={() => { this.openUrl(this.state.store.links.telegram) }}
									>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('telegram')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}
								{ this.state.store.links.linkedin != undefined && this.state.store.links.linkedin != "" && (
									<TouchableOpacity style={{marginLeft: 45, flexDirection: "row", height:60, 
														borderBottomWidth: 1, borderBottomColor: color.menuUnselected, justifyContent: "center", alignItems: "center"}}
														onPress={() => { this.openUrl(this.state.store.links.linkedin) }}
									>
										<Text style={{ fontFamily: 'main-regular',fontSize:16, color: "black"}}>{i18n.t('linkedin')}</Text>
										<Ionicons style={{marginLeft: "auto", marginRight: 15}} name={icoName} size={24} color={this.state.store.primaryColor} />			
									</TouchableOpacity>
								)}
						</View>					
					)}
                </ScrollView>

				<View style={styles.poweredby}>
					<Text>{i18n.t('poweredby')}</Text>
				</View>
			
            </View>					

        );  
    }  
}  

export default withNavigation(Menu);
  
const styles = StyleSheet.create({  
    container: {
        flex: 1, 
    },
    topBar: {
        height: 50,
        flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
	},
	imgGroup: {
		flexDirection: 'row', 
		justifyContent: 'center', 
		marginTop:30,
		flexWrap: 'wrap'
	},
	poweredby: {
		alignItems: 'center',
		position: 'absolute',
		bottom: 50,
		width: '100%',
	},
    button:{
        marginLeft: 55, 
        marginRight: 25, 
        height:60, 
        borderBottomWidth: 1, 
        borderBottomColor: color.menuUnselected, 
        justifyContent: "center"
    }
})  